import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6cd0cf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item active" }
const _hoisted_5 = { "aria-current": "location" }
const _hoisted_6 = { class: "position-relative clearfix" }
const _hoisted_7 = { class: "display-4" }
const _hoisted_8 = { class: "mt-2 d-block" }
const _hoisted_9 = { class: "card mb-1 d-flex flex-row px-3 py-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "ms-auto d-flex flex-column align-items-end" }
const _hoisted_13 = { class: "me-2" }
const _hoisted_14 = { class: "comments" }
const _hoisted_15 = { class: "mt-auto over time" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_IfFlag = _resolveComponent("IfFlag")
  const _component_user_link = _resolveComponent("user-link")
  const _component_icon = _resolveComponent("icon")
  const _component_time_ago = _resolveComponent("time-ago")

  return ($setup.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["MetaTag"], {
          name: "og:title",
          content: $setup.data.forum.title
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          name: "og:description",
          content: $setup.data.forum.description
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          name: "description",
          content: $setup.data.forum.description
        }, null, 8, ["content"]),
        _createVNode($setup["FeedTag"], { "object-id": $setup.id }, null, 8, ["object-id"]),
        _createVNode($setup["CanonicalRouteTag"]),
        _createVNode($setup["TitleTag"], {
          title: $setup.data.forum.title
        }, null, 8, ["title"]),
        _createElementVNode("ol", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, { to: "/forums" }, {
              default: _withCtx(() => [
                _createTextVNode("Forums")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString($setup.data.forum.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode($setup["FeedIcon"], {
            class: "float-end",
            "object-id": $setup.id
          }, null, 8, ["object-id"]),
          _createElementVNode("h1", _hoisted_7, _toDisplayString($setup.data.forum.title), 1),
          _createVNode(_component_IfFlag, {
            flag: $setup.data.forum.adminOnly ? 'can-create-post-adminonly' : 'can-create-post'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                class: "btn btn-success new-post mb-1",
                to: {name:'newpost', params:{id: $setup.route.params.id}}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("New post")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          }, 8, ["flag"]),
          _createElementVNode("p", null, _toDisplayString($setup.data.forum.description), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode($setup["Pagination"], {
            "fetch-items": $setup.fetchItems,
            "use-route": "use-route",
            "emit-load": "emit-load"
          }, {
            default: _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    class: "stretched-link post-title",
                    to: {name:'post', params:{id: item.id, name: item.uglytitle}}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, [
                    _createTextVNode("by "),
                    _createVNode(_component_user_link, {
                      class: "over",
                      user: item.author
                    }, null, 8, ["user"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_icon, {
                      class: _normalizeClass(["me-1 muted", {'text-danger': $setup.auth.currentUser && item.rating.likedBy.includes($setup.auth.currentUser.id)}]),
                      icon: "heart"
                    }, null, 8, ["class"]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(item.rating.score), 1),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_icon, {
                        class: "me-1 muted",
                        icon: "comment-alt"
                      }),
                      _createElementVNode("span", null, _toDisplayString(item.commentCount), 1)
                    ])
                  ]),
                  _createElementVNode("small", _hoisted_15, [
                    _createVNode(_component_time_ago, {
                      time: item.createdat
                    }, null, 8, ["time"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}